module.exports = {
  QUESTION_NUMBER: "Question number",
  QUESTION_SUBNUMBER: "Question subnumber",
  QUESTION_MAIN: "Question main",
  QUESTION_OPTION: "Question option",
  ANSWER: "Answer",
  TOTAL: "Total",
  MUJER: "Mujer",
  HOMBRE: "Hombre",
  "18A34": "18 a 34",
  "35A54": "35 a 54",
  "55A74": "55 a 74",
  "75YMAS": "75 y más",
  GRUPO_I: "Grupo I",
  GRUPO_II: "Grupo II",
  GRUPO_III: "Grupo III",
  GRUPO_IV: "Grupo IV",
  GRUPO_V: "Grupo V",
  NO_CODIFICABLE: "No codificable",
  RELACION_CERCANA: "Cercana",
  SIN_RELACION: "Sin relación",
  EXPERIENCIA_PROPIA: "Propia experiencia",
  SEGMENTS: [
    "Total",
    "Hombre",
    "Mujer",
    "18 a 34",
    "35 a 54",
    "55 a 74",
    "75 y más",
    "Grupo I",
    "Grupo II",
    "Grupo III",
    "Grupo IV",
    "Grupo V",
    "No codificable",
    "Sin relación",
    "Cercana",
    "Propia experiencia",
  ],
  SEGMENTS_SECTIONS: [
    {
      name: "Total",
      segments: ["Total"],
    },
    {
      name: "Por sexo",
      segments: ["Hombre", "Mujer"],
    },
    {
      name: "Por edad",
      segments: ["18 a 34", "35 a 54", "55 a 74", "75 y más"],
    },
    {
      name: "Por clase social",
      segments: [
        "Grupo I",
        "Grupo II",
        "Grupo III",
        "Grupo IV",
        "Grupo V",
        "No codificable",
      ],
    },
    {
      name: "Relación con el cáncer",
      segments: ["Sin relación", "Cercana", "Propia experiencia"],
    },
  ],
  MUY_GRAVE: "Muy grave",
  GRAVE: "Grave",
  POCO_GRAVE: "Poco grave",
  NSNC: "ns/nc",
  NSNC2: "ns/nc 2",
  MUY_MALO: "Muy malo",
  MALO: "Malo",
  REGULAR: "Regular",
  BUENO: "Bueno",
  MUY_BUENO: "Muy bueno",
  MUY_SALUDABLE: "Muy saludable",
  BASTANTE_SALUDABLE: "Bastante saludable",
  POCO_SALUDABLE: "Poco saludable",
  NADA_SALUDABLE: "Nada saludable",
  MUY_ALTO: "Muy alto",
  ALTO: "Alto",
  BAJO: "Bajo",
  MUY_BAJO: "Muy bajo",
  CANCER_ACTUALIDAD: "Tengo cáncer en la actualidad",
  A_MENUDO: "Si, a menudo",
  A_VECES: "Si, a veces",
  NO: "No",
  SI: "Si",
  TAN_PRONTO: "De inmediato",
  DE_2_A_3_SEMANAS: "2-3 semanas",
  DE_3_A_4_SEMANAS: "3-4 semanas",
  MENOS_DE_UNA_SEMANA: "Menos 1 semana",
  MAS_DE_UN_MES: "Más 1 mes",
  DE_1_A_2_SEMANAS: "1-2 semanas",
  NO_CONTACTARIA: "Nunca",
  OTRO_MEDICO: "Contactaría con otro profesional sanitario",
  EN_DESACUERDO: "En desacuerdo",
  DE_ACUERDO: "De acuerdo",
  TOTALMENTE_DESACUERDO: "Totalmente en desacuerdo",
  TOTALMENTE_ACUERDO: "Totalmente de acuerdo",
  AFECTA_MAS: "Afecta más a unas personas que otras",
  TODAS_PERSONAS_POSIBILIDADES:
    "Todas las personas tienen las mismas posibilidades",
};
